import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log("🟢 Auto-submit controller connected");
    this.element.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(event) {
    console.log("🔵 Click on:", event.target.tagName, event.target.className);

    // The checkbox has these specific classes, so look for it
    if (
      event.target.type === "checkbox" ||
      event.target.className.includes("peer absolute opacity-0")
    ) {
      console.log("🟠 Checkbox area clicked, submitting...");
      setTimeout(() => {
        console.log("🔴 Submitting form");
        this.submitForm();
      }, 100);
    }
  }

  submitForm() {
    this.element.requestSubmit();
  }
}
